// This file is replaced by Localazy.
export default {
  languages: [
    {
      language: 'en',
    },
  ],
};
